import styled from 'styled-components';

import { white, lightGrey } from 'styles/colors';
import { fromLarge } from 'styleUtils/mediaQueries';

const amountOfWhiteSpaceY = '90px';

interface SectionProps {
    isEven?: boolean;
    hasWhiteSpace?: boolean;
}

export const Section = styled.div<SectionProps>`
    position: relative;
    ${fromLarge`
    ${({ hasWhiteSpace }): string => (hasWhiteSpace ? `padding: ${amountOfWhiteSpaceY} 0` : ``)};
  `};
    background: ${({ isEven }): string => (isEven ? white : lightGrey)};
`;
